import MUILink from '@mui/material/Link'
import PropTypes from 'prop-types'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

const Link = ({ children, href, variant, target, rel, onClick, component }) => (
  <MUILink
    href={href}
    variant={variant}
    target={target}
    rel={rel}
    onClick={onClick}
    component={component}
  >
    {children}
  </MUILink>
)

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  variant: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  onClick: PropTypes.func,
  component: PropTypes.string,
}

Link.defaultProps = {
  href: null,
  variant: null,
  target: null,
  rel: null,
  onClick: null,
  component: 'a',
}

const InternalLink = ({ children, variant, to }) => (
  <MUILink to={to} variant={variant} component={RouterLink}>
    {children}
  </MUILink>
)

InternalLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  variant: PropTypes.string,
}

InternalLink.defaultProps = {
  to: null,
  variant: null,
}

Link.Internal = InternalLink

export default Link
